import { postData } from "./apis";

const path = "/manufacturing/bom";

export const bomListApi = () => {
  return postData(`${path}/list`, {});
};

export const bomGetByItemApi = (item_id) => {
  return postData(`${path}/get-by-item`, { item_id });
};

export const bomSaveApi = (payload) => {
  return postData(`${path}/save`, payload);
};

export const bomDeleteApi = (bom_id) => {
  return postData(`${path}/delete`, { bom_id });
};
